import { IEventWasUpdated } from '../../../actions/bookingCalendar/event/requestUpdateEvent'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IEventWasUpdated,
): IEventsStore {
  return {
    ...state,
    events: [
      ...state.events.filter(event => event.id !== action.event.id),
      action.event,
    ],
  }
}
